import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Cerere, DocGenerate } from '../../cereri.interface';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { ReplaySubject, Subject } from 'rxjs';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CereriService } from '../../cereri.service';
import { NotificationService } from 'src/app/services/notification.service';
import { DataTableDirective } from 'angular-datatables';
import { helper } from 'src/environments/helper';
import { AppFilesService } from 'src/app/services/app-files.service';
import Swal from 'sweetalert2';
import { MatDialog } from '@angular/material/dialog';
import { DialogService } from 'src/app/layout/services/dialog.service';
import { ViewMatricoleComponent } from './view-matricole/view-matricole.component';
import { BreakpointObserver } from '@angular/cdk/layout';
import { ViewMatricoleCfComponent } from './view-matricole-cf/view-matricole-cf.component';

@Component({
    selector: 'app-documente-generate',
    templateUrl: './documente-generate.component.html',
    styleUrls: ['./documente-generate.component.scss']
})
export class DocumenteGenerateComponent implements OnInit, OnDestroy {
    @Input() cerere!: Cerere;
    @Output() requestInfoUpdated: EventEmitter<void> = new EventEmitter();

    // general error
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;

    // general success alert
    successTitle: string = environment.config.customNotifications.headers.successForm;
    successIcon: string = environment.config.customNotifications.icons.success;
    successType: string = environment.config.customNotifications.icons.success;

    helper = helper;

    form!: FormGroup;

    isLoading = false;
    viewMatricole = false;
    disableBtnMatricole = false;

    dtLink = environment.interop.basePath + environment.interop.dgitl.cerere.getMatricole;

    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;

    dtOptions: any = {};
    dtTrigger: ReplaySubject<any> = new ReplaySubject<any>();
    dtInstance!: DataTables.Api;

    selectedRowIds: number[] = [];
    rowCount = 0;
    checkboxSelections = false;

    matricole!: [];
    matricoleLoaded!: number;

    matricoleOperatii: { key: string; value: number }[] = [
        { key: 'Află Status', value: 0 },
        { key: 'Emitere', value: 1 },
        { key: 'Reemitere', value: 2 },
    ]

    matricoleScopuriCF: { key: string; value: number }[] = [
        { key: 'Cu Specificație', value: 0 },
        { key: 'Vânzare', value: 1 },
        { key: 'Succesiune', value: 2 },
    ]

    matricoleYesNo: { key: string; value: number }[] = [
        { key: 'NU', value: 0 },
        { key: 'DA', value: 1 },
    ]

    constructor(
        private http: HttpClient,
        private fb: FormBuilder,
        private cereriService: CereriService,
        private appFilesService: AppFilesService,
        private dialog: MatDialog,
        private breakpointObserver: BreakpointObserver,
        private notificationService: NotificationService,
    ) { }

    ngOnInit(): void {
        this.initForm();
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    initForm() {
        this.form = this.fb.group({
            operatie: new FormControl('', [Validators.required]),
            scopcf: new FormControl('', [Validators.required]),
            fara_patrimoniu: new FormControl(0),
            specificatii: new FormControl('', [Validators.required]),
            alte_mentiuni: new FormControl(''),
        })
    }

    getMatricole() {
        this.processDTMatricole();
        this.viewMatricole = true;
        this.dtTrigger.next('');
    }

    rerenderDT(): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next('');
        });
    }

    processDTMatricole() {
        const self = this;
        this.isLoading = true;

        this.dtOptions = {
            responsive: true,
            serverSide: false,
            searching: true,
            pageLength: 5,
            lengthMenu: [5, 10, 15],
            order: [[1, 'desc']],
            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;
                this.http
                    .get<any>(this.dtLink + this.cerere.id_cerere)
                    .subscribe({
                        next: (resp: any) => {
                            this.isLoading = false;
                            this.getTableRowCount();
                            this.checkboxesReset();

                            this.matricole = resp.data;
                            this.matricoleLoaded = resp.data.length;

                            callback({
                                recordsTotal: resp.data.length,
                                recordsFiltered: resp.data.length,
                                data: resp.data,
                            });
                        },
                        error: (err) => {
                            this.closeMatricole();
                            this.notificationService.warningSwal(this.errorTitle, err.error.errors.message, this.errorIcon);
                        }
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columns: [
                {
                    title: `<input type="checkbox" class="row-checkbox" style="width: 20px; height: 20px;" id="headerCheckbox"/>`,
                    data: 'matricola',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        return `<input type="checkbox" class="row-checkbox" style="width: 20px; height: 20px;" value="${row.matricola}" />`
                    }
                },
                {
                    title: 'Nr. Matricolă',
                    data: 'matricola',
                },
                {
                    title: 'Nume Matricolă',
                    data: 'numeTip',
                    sortable: false,
                },
                {
                    title: 'Adresa',
                    data: 'adresa',
                    sortable: false,
                },
                {
                    title: 'Descriere',
                    data: 'descriere',
                    sortable: false,
                }
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                $('td', row).off('click');
                // Handle click event on the CHECKBOXES
                $(row)
                    .find('.row-checkbox')
                    .off('change')
                    .on('change', function () {
                        let matricola = Number($(this).val());

                        if ($(this).is(':checked')) {
                            self.selectedRowIds.push(matricola);

                        } else {
                            self.selectedRowIds = self.selectedRowIds.filter(
                                (id) => id !== matricola
                            );
                        }

                        if (self.rowCount !== self.selectedRowIds.length) {
                            self.checkHeaderCheckBox(false);
                        } else if (self.rowCount === self.selectedRowIds.length) {
                            self.checkHeaderCheckBox(true);
                        }

                        self.checkboxSelections = self.selectedRowIds.length > 0;
                    });

                return row;
            },
            headerCallback: (row: Node, data: any[] | any) => {
                const headerCheckbox = $(row).find('#headerCheckbox');

                // Remove any existing event handlers to avoid duplicating them
                headerCheckbox.off('change click');

                // Handle the change event for selecting/deselecting all checkboxes
                headerCheckbox.on('change', function () {
                    if ($(this).is(':checked')) {
                        self.selectedRowIds.length = 0;
                        data.forEach((item: any) => {
                            self.selectedRowIds.push(item.matricola);
                        });
                        self.checkMultipleCheckboxesByValue(true);
                    } else {
                        self.selectedRowIds.length = 0;
                        self.checkMultipleCheckboxesByValue(false);
                    }
                    self.checkboxSelections = self.selectedRowIds.length > 0;
                });

                // Prevent sorting when clicking the checkbox
                headerCheckbox.on('click', function (e) {
                    e.stopPropagation();
                });

                return row;
            },
        }
    }

    closeMatricole() {
        this.viewMatricole = false;
        this.dtTrigger = new ReplaySubject<any>();
        this.checkboxSelections = false;
        this.initForm();
    }

    async getTableRowCount() {
        const table = await this.dtElement.dtInstance;
        this.rowCount = table.rows().count();
    }

    checkHeaderCheckBox(checkValue: boolean) {
        const headerCheckbox = document.getElementById(
            'headerCheckbox'
        ) as HTMLInputElement;
        headerCheckbox.checked = checkValue;
    }

    checkMultipleCheckboxesByValue(checkValue: boolean) {
        let checkboxes = document.querySelectorAll<HTMLInputElement>(
            'input[type="checkbox"]'
        );
        checkboxes.forEach((checkbox) => {
            checkbox.checked = checkValue;
        });
    }

    checkboxesReset() {
        this.selectedRowIds.length = 0;
        this.checkMultipleCheckboxesByValue(false);
        this.checkHeaderCheckBox(false);
        this.checkboxSelections = false;
    }

    viewMatricoleCF(row: DocGenerate) {
        const data = { matricole_json: row.matricole_json, matricole_arr: row.matricole_arr };

        let configData = {
            data: { ...data },
            disableClose: true,
            width: '60%',
            height: 'auto',
            minWidth: '275px',
        };

        const dialogRef = this.dialog.open(ViewMatricoleCfComponent, configData);

        const layoutChanges = this.breakpointObserver.observe([
            '(max-width: 599px)', // xs breakpoint
            '(min-width: 600px)'  // sm breakpoint
        ]);

        const layoutChangeSubscription = layoutChanges.subscribe(result => {
            if (result.matches) {
                if (result.breakpoints['(max-width: 599px)']) {
                    // Smaller devices          
                    dialogRef.updateSize('95%', 'auto')
                } else {
                    // Larger devices
                    dialogRef.updateSize('40%', 'auto')
                }
            }
        });

        dialogRef.afterClosed().subscribe(() => {
            layoutChangeSubscription.unsubscribe()
        })
    }

    downloadCF(id: number) {
        let fullPath = this.cereriService.downloadCFUrl + id;
        this.isLoading = true;
        this.appFilesService.downloadFile(fullPath)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('DownloadCF error: ', err);
                this.isLoading = false;
            })
    }

    cancelCF(id: number) {
        Swal.fire({
            title: helper.swalTextConfig.commonTitles.areYouSure,
            text: 'O să anulați CF-ul curent',
            showCancelButton: true,
            confirmButtonText: helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText: helper.swalTextConfig.validationMessages.cancelButton,
            reverseButtons: true,
            input: 'text',
            inputPlaceholder: 'Motiv de anulare',
            inputValidator: (value: any) => {
                if (!value) {
                    return 'Trebuie să adăugați motivul anulării!';
                }
                return null;
            },
            showLoaderOnConfirm: true,
            preConfirm: (inputValue) => {
                return this.cereriService
                    .cancelCF(id, { motiv: inputValue })
                    .toPromise()
                    .then((res) => {
                        return res;
                    })
                    .catch((err) => {
                        Swal.showValidationMessage(`Cancel failed: ${err}`);
                    })
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((res) => {
            if (res.isConfirmed) {
                Swal.fire({
                    title: helper.swalTextConfig.headers.success,
                    text: 'CF anulat cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.requestInfoUpdated.emit();
                })
            }
        })
    }

    previewMatricoleForConfirmation() {
        let all = this.selectedRowIds.length == this.matricoleLoaded;

        const matricole = this.matricole.filter(
            (item: any) => this.selectedRowIds.includes(item.matricola)
        )

        const data = { all: all, loaded: this.selectedRowIds, ...this.form.value, allMatricole: this.matricole.length, id_cerere: this.cerere.id_cerere };

        let configData = {
            data: { ...data, matricole },
            disableClose: true,
            width: '60%',
            height: 'auto',
            minWidth: '275px',
        };

        const dialogRef = this.dialog.open(ViewMatricoleComponent, configData);

        const layoutChanges = this.breakpointObserver.observe([
            '(max-width: 599px)', // xs breakpoint
            '(min-width: 600px)'  // sm breakpoint
        ]);

        const layoutChangeSubscription = layoutChanges.subscribe(result => {
            if (result.matches) {
                if (result.breakpoints['(max-width: 599px)']) {
                    // Smaller devices          
                    dialogRef.updateSize('95%', 'auto')
                } else {
                    // Larger devices
                    dialogRef.updateSize('40%', 'auto')
                }
            }
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.requestInfoUpdated.emit();
                this.closeMatricole();
            }
            layoutChangeSubscription.unsubscribe()
        })
    }

    formatCreatedAt(created_at: string): string {
        return new Date(created_at).toLocaleString('ro-RO');
    }
}
